module.exports = __webpack_public_path__ + "static/media/svg-3.e52e1704.svg";